import { createContext } from "react";

export interface AudioInfo {
  src: string;
  fileName: string;
  isPlaying: boolean;
  isLoading: boolean;
  currentTime: number;
  duration: number;
}

export interface MediaPlayerContextValue {
  currentAudio: AudioInfo | null;
  playAudio: (src: string, fileName: string, duration?: number) => void;
  pauseAudio: () => void;
  resumeAudio: () => void;
  stopAudio: () => void;
  setCurrentTime: (time: number) => void;
}

export const MediaPlayerContext = createContext<MediaPlayerContextValue | null>(
  null
);
